const CommunitiesSection = () => (
  <section className="grid__container">
    <div className="grid__row content-block">
      <div className="grid__column--12">
        <h2>Communities</h2>
        <div>
          <p>
            At Skyscanner, we want to give back to the communities that surround
            us. Our charitable approach reflects our goal of increasing
            diversity and accessibility in tech: in our business, sector and
            beyond. We recognise that in order to address the long-term
            diversity of the tech sector, we need to change the make up of those
            taking up coding as a career.
          </p>
          <p>
            We provide financial and volunteering support to charities who are
            experts in making this happen, whether at pipeline stage (with a
            focus on women and minorities in tech) or through tech education at
            school level.
          </p>
          <p>
            We also support our employees&#39; own fundraising efforts, with up
            to £500 matched per person. We have set aside a budget for
            humanitarian aid every year, and give every employee a paid day to
            volunteer annually.
          </p>
        </div>
      </div>
    </div>

    <div className="grid__row content-block">
      <div className="video-container--landscape">
        <video
          className="video"
          controls
          src="https://content.skyscnr.com/m/32572cd3386772a4/original/CFG-graduate-video-WITH-SUBS.mp4"
          width="100%"
        >
          <track
            src="../../transcripts/Skyscanner-code-first-girls-en-US.vtt"
            kind="captions"
            label="English"
          />
        </video>
      </div>
    </div>

    <div className="grid__row community-quotes-container content-block">
      <div className="grid__column--6 grid__column--tablet-12 quote-column">
        <div className="quote-image-container code-your-future-logo-container">
          <img
            className="quote-logo"
            alt="Code Your Future logo"
            src="https://content.skyscnr.com/m/402a2c9e14550512/original/code-your-future-logo.png"
          />
        </div>
        <p className="community-quote">
          “Having childcare support during my training with CYF was an absolute
          lifeline, especially with the high cost of childcare and rising living
          expenses. Without a personal support system to rely on, this
          assistance allowed me to fully engage in Saturday live sessions and
          dedicate time during the week to study and complete projects. It made
          it possible for me to balance parenthood and pursue my career goals,
          something that would have been nearly impossible without this vital
          support.”
        </p>
        <p className="sub-heading">Bedi, Code Your Future graduate</p>
      </div>

      <div className="grid__column--6 grid__column--tablet-12 quote-column">
        <div className="quote-image-container">
          <img
            className="quote-logo"
            alt="Digital Xtra logo"
            src="https://content.skyscnr.com/m/791319de34fbd888/original/digital-xtra-logo.jpg"
          />
        </div>
        <p className="community-quote">
          “I like the Technicoders because we got to explore different aspects
          of tech and learn new things. When I&apos;m older, I will want to work
          in tech especially since there is likely to be more advanced tech in
          the future and we will be more surrounded by it.”
        </p>
        <p className="sub-heading">Zoe, 12, supported by Digital Xtra</p>
      </div>
    </div>

    <hr aria-hidden="true" />
  </section>
);

export default CommunitiesSection;
